'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeParseContext$() {
}
export { $c_Ljava_time_format_internal_TTBPDateTimeParseContext$ as $c_Ljava_time_format_internal_TTBPDateTimeParseContext$ };
$p = $c_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_internal_TTBPDateTimeParseContext$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeParseContext$() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeParseContext$ as $h_Ljava_time_format_internal_TTBPDateTimeParseContext$ };
$h_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype = $p;
$p.SF = (function(c1, c2) {
  return (((c1 === c2) || ($j_java$002elang$002e$002dObject.$m_jl_Character$().yd(c1) === $j_java$002elang$002e$002dObject.$m_jl_Character$().yd(c2))) || ($j_java$002elang$002e$002dObject.$m_jl_Character$().QK(c1) === $j_java$002elang$002e$002dObject.$m_jl_Character$().QK(c2)));
});
var $d_Ljava_time_format_internal_TTBPDateTimeParseContext$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_internal_TTBPDateTimeParseContext$, "java.time.format.internal.TTBPDateTimeParseContext$", ({
  lI: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeParseContext$ as $d_Ljava_time_format_internal_TTBPDateTimeParseContext$ };
var $n_Ljava_time_format_internal_TTBPDateTimeParseContext$;
function $m_Ljava_time_format_internal_TTBPDateTimeParseContext$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeParseContext$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeParseContext$ = new $c_Ljava_time_format_internal_TTBPDateTimeParseContext$();
  }
  return $n_Ljava_time_format_internal_TTBPDateTimeParseContext$;
}
export { $m_Ljava_time_format_internal_TTBPDateTimeParseContext$ as $m_Ljava_time_format_internal_TTBPDateTimeParseContext$ };
